import React, { useState, useEffect } from 'react';
import { DetailItem } from 'app/shared/info-section/item';
import { BasicInfoSection } from 'app/shared/info-section/basic';
import { GridColumn, GridRow } from 'app/layouts/grid';
import { Spacer } from 'app/layouts/generic';
import { Icon } from 'assets/icons';
import { useInvoiceService } from 'hooks/sales/invoice';
import { toDateString } from 'app/shared/utils/date';
import styles from './invoice.module.css';
import { toast } from 'react-toastify';
import { Badge } from 'app/shared/badge';
import { toReadableNumber } from 'app/shared/utils/number';

export const InvoiceList = () => {
  const { fetchInvoices } = useInvoiceService();
  const [invoices, setInvoices] = useState([]);
  const [visible_invoices, setVisibleInvoices] = useState(3);
  const [has_more, setHasMore] = useState(true);

  useEffect(() => {
    fetchInvoices().then(({ invoices, error }) => {
      if (error) return toast.error(error);
      const sorted_invoices = invoices
        .filter((invoice) => invoice.subscription_id)
        .sort((a, b) => new Date(b.created_on) - new Date(a.created_on));
      setHasMore(sorted_invoices.length > visible_invoices);
      setInvoices(sorted_invoices);
    });
  }, []);

  const loadMoreInvoices = () => {
    setVisibleInvoices((prevVisibleInvoices) => prevVisibleInvoices + 3);
    setHasMore(invoices.length >= visible_invoices);
  };

  const styleStatusBadge = (status) => {
    switch (status) {
      case 'paid':
        return <Badge type="green" text={status} />;
      case 'unpaid':
        return <Badge type="red" text={status} />;
    }
  };

  const handleDownload = (link) => {
    if (!link) return toast.error('Error downloading Invoice.');
    window.open(link, '_blank');
  };

  return (
    <BasicInfoSection title="Invoices">
      <div>
        {invoices.slice(0, visible_invoices).map((invoice, index) => (
          <GridRow key={index} num_of_columns={8}>
            <GridColumn span={4}>
              <DetailItem title="DATE">{toDateString(invoice.due_date)}</DetailItem>
            </GridColumn>
            <GridColumn span={2}>
              <DetailItem title="AMOUNT">{toReadableNumber(invoice.cost)}</DetailItem>
            </GridColumn>
            <GridColumn span={1}>
              <DetailItem title="STATUS">{styleStatusBadge(invoice.status)}</DetailItem>
            </GridColumn>
            <GridColumn>
              <DetailItem title=".">
                <span style={{ display: 'flex', justifyContent: 'center' }}>
                  <Icon
                    height={18}
                    width={18}
                    name="download"
                    onClick={() => {
                      handleDownload(invoice?.pdf_link);
                    }}
                  />
                </span>
              </DetailItem>
            </GridColumn>
          </GridRow>
        ))}
        <Spacer multiple={2} />
        {has_more && (
          <a className={styles.readMore} onClick={loadMoreInvoices}>
            Load More
          </a>
        )}
        <Spacer multiple={2} />
      </div>
    </BasicInfoSection>
  );
};
